import PosthogService from '~/services/posthog/PosthogService';

export function fireDashboardPendingReviewTabClicked(): void {
  PosthogService.getInstance().track('dental_portal:dashboard:pending_review_tab_clicked');
}
